var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardImage.js",
    _this = this;

import { Image, ImageWrapper, OverlayWrapper, Tag, TagWrapper } from './style';
import React, { isValidElement } from 'react';
var defaultProps = {
  customStyle: {
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(34, 34, 34, 0) 100%)"
  }
};

var ImageTag = function ImageTag(_ref) {
  var tag = _ref.tag;

  if ( /*#__PURE__*/isValidElement(tag)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, tag);
  }

  if (tag) {
    return /*#__PURE__*/React.createElement(TagWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 18,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Tag, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 9
      }
    }, tag));
  }

  return null;
};

var CardImage = function CardImage(_ref2) {
  var src = _ref2.src,
      ratio = _ref2.ratio,
      tag = _ref2.tag,
      overlayContent = _ref2.overlayContent,
      propsCustomStyle = _ref2.customStyle;
  var customStyle = Object.assign({}, defaultProps.customStyle, propsCustomStyle);
  return /*#__PURE__*/React.createElement(ImageWrapper, {
    ratio: ratio,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: src.url,
    alt: src.alt,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ImageTag, {
    tag: tag,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }), overlayContent && /*#__PURE__*/React.createElement(OverlayWrapper, {
    customStyle: customStyle,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }, overlayContent));
};

export default CardImage;